import React, { useState } from 'react';

interface DebugOverlayProps {
  lines: string[];
  label?: string;
  color?: string;
}

export function DebugOverlay({ lines, label = 'Debug', color = '#88ccff' }: DebugOverlayProps) {
  const [expanded, setExpanded] = useState(false);

  if (lines.length === 0) return null;

  const lastLine = lines[lines.length - 1] ?? '';

  return (
    <div
      onClick={() => setExpanded(v => !v)}
      style={{
        position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 9999,
        background: 'rgba(0,0,0,0.85)',
        borderTop: '1px solid #333',
        cursor: 'pointer',
        userSelect: 'none',
        transition: 'max-height 0.2s ease',
        maxHeight: expanded ? '40vh' : 24,
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {/* Bandeau collapsed */}
      <div style={{
        display: 'flex', alignItems: 'center', gap: 6,
        padding: '0 10px',
        height: 24, minHeight: 24, flexShrink: 0,
        fontFamily: 'monospace', fontSize: 10, color: '#888',
      }}>
        <span style={{ color }}>🐞</span>
        <span style={{ color: '#aaa', fontWeight: 'bold' }}>{label}</span>
        <span style={{ flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', color: '#666' }}>
          {lastLine}
        </span>
        <span style={{ color: '#555' }}>{expanded ? '▼' : '▲'}</span>
      </div>

      {/* Logs scrollables */}
      <div
        onClick={e => e.stopPropagation()}
        style={{
          flex: 1, overflowY: 'auto',
          padding: '4px 10px 10px',
          fontFamily: 'monospace', fontSize: 11, color,
        }}
      >
        {lines.map((l, i) => <div key={i} style={{ lineHeight: '1.5' }}>{l}</div>)}
      </div>
    </div>
  );
}
